import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})


export class HomeComponent implements OnInit {


  // diapo var
  dislayDiapo = false;
  srcSelected = ""
  numSelected = 0

  constructor() { 
  }

  
  ngOnInit() {
    window.scrollTo(0,0);
  }





  // ################################ Diapo Functions ################################
  // ################################ Diapo Functions ################################
  // ################################ Diapo Functions ################################

  onDiapo(numDiapo: number){
    this.dislayDiapo = true;
    this.numSelected = numDiapo;
    this.srcSelected = "assets/img/exemple/exemple" + String(numDiapo) + ".jpg";
  }

  onNextDiapo(){
    this.numSelected = (this.numSelected + 1)%4;
    this.srcSelected = "assets/img/exemple/exemple" + String(this.numSelected) + ".jpg";
  }

  onPreviousDiapo(){
    this.numSelected = (this.numSelected - 1)%4;
    if (this.numSelected < 0){
      this.numSelected = 4 + this.numSelected;
    }
    this.srcSelected = "assets/img/exemple/exemple" + String(this.numSelected) + ".jpg";

  }

  onStopDiapo(){
    this.dislayDiapo = false;
    this.srcSelected = "";
  }




}


